// extracted by mini-css-extract-plugin
export default {"moreBtn":"OrderItemActionsDropdown_moreBtn__CII5x","cancelOrder":"OrderItemActionsDropdown_cancelOrder__Wi7nB"};